import { useCallback, useEffect, useState } from "react";
import createPlotlyComponent from "react-plotly.js/factory";
import Plotly from "plotly.js-dist-min";

const Plot = createPlotlyComponent(Plotly);

const HeatmapPlot = ({ isLoading, data, objects, shape }) => {
  const [chartData, setChartData] = useState();
  const [chartLayout, setChartLayout] = useState();
  const [showPlot, setShowPlot] = useState(false);

  const createChartLayout = useCallback(() => {
    const plotLayout = {
      autosize: false,
      width: "860",
      height: "800",
      margin: { l: 60, r: 20, b: 60, t: 20 },
      paper_bgcolor: "rgba(0,0,0,0)",
      plot_bgcolor: "rgba(0,0,0,0)",
      xaxis: {
        tickfont: { color: "white" },
        titlefont: { color: "white" },
        linecolor: "white",
        zeroline: false,
        automargin: true,
      },
      yaxis: {
        tickfont: { color: "white" },
        titlefont: { color: "white" },
        linecolor: "white",
        zeroline: false,
        automargin: true,
      },
      legend: {
        font: { color: "white" },
        bgcolor: "rgba(0,0,0,0)",
      },
      font: {
        color: "white",
      },
    };
    setChartLayout(plotLayout);
  }, []);

  const createChartData = useCallback(() => {
    const zData = [];

    // Create rows for each node score
    objects.forEach((objectY) => {
      const row = [];
      objects.forEach((objectX) => {
        const datapoint = data.find(
          (dataItem) => dataItem.src === objectY && dataItem.dst === objectX
        );

        if (objectY === objectX && !datapoint) {
          row.push(1);
          return;
        }
        if (objectY !== objectX && !datapoint) {
          row.push(0);
          return;
        }

        row.push(datapoint?.v);
      });
      zData.push(row);
    });

    // Generate chart data objects
    const plotData = [
      {
        type: "heatmap",
        z: zData,
        x: objects,
        y: objects,
        name: "",
        hovertemplate: "",
      },
    ];
    setChartData(plotData);
  }, [objects, data]);

  useEffect(() => {
    if (isLoading || !data || !objects || !shape) {
      setShowPlot(false);
      setChartLayout(null);
      setChartData(null);
      return;
    }

    setShowPlot(true);
    createChartData();
    createChartLayout();
  }, [objects, shape, data, createChartData, createChartLayout, isLoading]);

  return (
    <div className="flex flex-col items-center content-center min-w-50">
      {isLoading && <p className="text-center">Loading data...</p>}
      {!isLoading && chartLayout && chartData && showPlot && (
        <Plot data={chartData} layout={chartLayout} />
      )}
    </div>
  );
};

export default HeatmapPlot;
